module.exports = __webpack_public_path__ + "static/media/icon_documentacao.ad28cf09.svg";